import { ChannelType } from '@wix/ambassador-ecom-v1-order/types';
import { OrderStatus } from '@wix/restaurants-types';
import { contactParser } from '../../utils/parse';
import { utils } from '../../utils';
import { FulfillmentMethodType } from '../../types';
export function orderNormalizer(_ref) {
  var _order$buyerInfo, _order$shippingInfo, _order$shippingInfo2, _order$shippingInfo3, _order$channelInfo, _order$channelInfo2, _order$shippingInfo4, _order$shippingInfo5, _order$shippingInfo6;
  let {
    options,
    order
  } = _ref;
  const contactName = (() => {
    const {
      firstName,
      lastName
    } = order.billingInfo.contactDetails;
    return contactParser.parseName(firstName, lastName, options.defaultContactName, options.fullNameFormatter);
  })();
  const contactId = ((_order$buyerInfo = order.buyerInfo) == null ? void 0 : _order$buyerInfo.contactId) ?? undefined;
  const contactPhoneNumber = order.billingInfo.contactDetails.phone ?? undefined;
  const fulfillmentMethodType = getFulfillmentMethodType((_order$shippingInfo = order.shippingInfo) == null ? void 0 : _order$shippingInfo.logistics);
  const fulfillmentDateTimeFrom = ((_order$shippingInfo2 = order.shippingInfo) == null || (_order$shippingInfo2 = _order$shippingInfo2.logistics) == null || (_order$shippingInfo2 = _order$shippingInfo2.deliveryTimeSlot) == null ? void 0 : _order$shippingInfo2.from) ?? undefined;
  const fulfillmentDateTimeTo = ((_order$shippingInfo3 = order.shippingInfo) == null || (_order$shippingInfo3 = _order$shippingInfo3.logistics) == null || (_order$shippingInfo3 = _order$shippingInfo3.deliveryTimeSlot) == null ? void 0 : _order$shippingInfo3.to) ?? undefined;
  const isCanceled = order.status === OrderStatus.CANCELED;
  const isManualOrder = ((_order$channelInfo = order.channelInfo) == null ? void 0 : _order$channelInfo.type) === ChannelType.BACKOFFICE_MERCHANT;
  const isPOSOrder = ((_order$channelInfo2 = order.channelInfo) == null ? void 0 : _order$channelInfo2.type) === ChannelType.POS;
  const isPickupOrder = !!((_order$shippingInfo4 = order.shippingInfo) != null && (_order$shippingInfo4 = _order$shippingInfo4.logistics) != null && _order$shippingInfo4.pickupDetails);
  const formattedPrice = order.priceSummary.total.formattedAmount;
  const restaurantsOrderStatus = utils.status.getRestaurantsOrderStatus(order.id, order.fulfillmentStatusesAggregate);
  const totalItems = order.lineItems.reduce((sumOfLineItems, currentLineItem) => {
    return sumOfLineItems + currentLineItem.quantity;
  }, 0);
  const deliveryAddress = (_order$shippingInfo5 = order.shippingInfo) == null || (_order$shippingInfo5 = _order$shippingInfo5.logistics) == null || (_order$shippingInfo5 = _order$shippingInfo5.shippingDestination) == null ? void 0 : _order$shippingInfo5.address;
  const formattedDeliveryAddress = deliveryAddress ? utils.address.toFormattedAddress(deliveryAddress, {
    hidePostalCode: options.hidePostalCode
  }) : undefined;
  const pickupAddress = (_order$shippingInfo6 = order.shippingInfo) == null || (_order$shippingInfo6 = _order$shippingInfo6.logistics) == null || (_order$shippingInfo6 = _order$shippingInfo6.pickupDetails) == null ? void 0 : _order$shippingInfo6.address;
  const formattedPickupAddress = pickupAddress ? utils.address.toFormattedAddress(pickupAddress, {
    hidePostalCode: options.hidePostalCode
  }) : undefined;
  return {
    contactName,
    contactId,
    contactPhoneNumber,
    fulfillmentMethodType,
    formattedDeliveryAddress,
    formattedPickupAddress,
    formattedPrice,
    fulfillmentDateTimeFrom,
    fulfillmentDateTimeTo,
    isCanceled,
    isManualOrder,
    isPOSOrder,
    isPickupOrder,
    order,
    restaurantsOrderStatus,
    totalItems
  };
}
function getFulfillmentMethodType(logistics) {
  if (logistics != null && logistics.pickupDetails) {
    return FulfillmentMethodType.PICKUP;
  }
  if (logistics != null && logistics.shippingDestination) {
    return FulfillmentMethodType.DELIVERY;
  }
  return FulfillmentMethodType.NONE;
}
//# sourceMappingURL=order-normalizer.js.map